import { utils } from "../../core/helpers/utils";
import find from "lodash/find";
import chunk from "lodash/chunk";
import zipWith from "lodash/zipWith";
import moment from "moment";
import { store } from "../../store";

export const portfolioHelpers = {
  getPortfolioDetails,
  getFormattedSips,
  getFormattedFundTransactions,
  getFormattedTransactions,
  getTimelineDurations,
  getFormattedSips,
  getNavGraphData,
  getGraphDetails,
  getFundsSortingOptions,
  getSipsFilterOptions,
  getInvestmentSummary,
  getFormattedSipsOvd,
};

function getPortfolioDetails(portfolio) {
  if (portfolio.portfolioDetails && portfolio.portfolioDetails.funds) {
    var investmentSummary = getInvestmentSummary(
      portfolio.portfolioDetails,
      portfolio.portfolioGraph
    );

    var investmentDetails = getInvestmentDetails(
      portfolio,
      portfolio.portfolioGraph
    );

    var graphDetails = {};
    // getGraphDetails(portfolio.portfolioGraph);
    // graphDetails['totalInvestment'] = investmentSummary.totalInvestment;
    // graphDetails['pnlValue'] = investmentSummary.pnlValue;
    // graphDetails['pnlPercent'] = investmentSummary.pnlPercent;

    return {
      investmentSummary: investmentSummary,
      investmentDetails: investmentDetails,
      graphDetails: graphDetails,
      switchAnalysis: portfolio.portfolioDetails.switchAnalysis,
      commissionAnalysis: portfolio.portfolioDetails.cmsnAnalysis,
      commissionPaid: utils.formatCurrency(portfolio.portfolioDetails.cmsnPaid),
      sellPf: formatSellPf(portfolio.portfolioDetails.sellPF),
    };

    //commissionAnalysis: getCommissionAnalysis(portfolio.portfolioDetails.cmsnAnalysis)
  } else {
    return {
      investmentDetails: {
        funds: [],
        sips: [],
        // timeline: {},
      },
      // isEmpty: true
    };
  }
}

function getInvestmentSummary(portfolioDetails, portfolioGraph) {
  var portfolio = {};

  portfolio["funds"] = portfolioDetails.funds || portfolioDetails.schemeName;

  // portfolio['totalInvestment'] = utils.formatCurrency(portfolioDetails.mtm);
  portfolio["totalInvestment"] = portfolioDetails.mtm.oroNumber(0, true);
  // console.log(portfolioDetails.mtm,portfolioDetails.mtm.oroNumber(0,true) ,"prototype check 3")
  //utils.formatCurrency(portfolioDetails.mtm);

  portfolio["yesterdaysPnlPerc"] = portfolioDetails.yesterdaysPnlPerc;
  portfolio["yesterdaysPnl"] = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(portfolioDetails.yesterdaysPnl);

  portfolio["pnlValue"] =
    portfolioDetails.mtm - portfolioDetails.investmentAmt &&
    (portfolioDetails.mtm - portfolioDetails.investmentAmt).oroNumber(0, true);

  portfolio["pnlPercent"] =
    portfolioDetails.investmentAmt !== 0
      ? (
          ((portfolioDetails.mtm - portfolioDetails.investmentAmt) * 100) /
          portfolioDetails.investmentAmt
        ).toFixed(2)
      : 0;

  portfolio["info"] = [];
  portfolio["invested"] = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(portfolioDetails.investmentAmt);

  portfolio["xirr"] = portfolioDetails.xirr;
  portfolio["xirrLive"] = portfolioDetails.xirrLive;
  portfolio["equity"] = parseFloat(portfolioDetails.equity).toFixed(2);

  portfolio["debt"] = parseFloat(100 - portfolioDetails.equity).toFixed(2);

  portfolio.info.push({ title: "Invested", value: portfolio.invested });

  var plValue = portfolioDetails.mtm - portfolioDetails.investmentAmt;
  portfolio.info.push({
    title: "Total P/L",
    value: plValue.oroNumber(0, true),
    color: plValue > 0 ? "primary" : "danger",
  });

  portfolio.info.push({
    title: "Annualised Returns",
    value: portfolioDetails.xirr + "%",
    tooltipText:
      "Portfolio returns generated since inception on a yearly basis. This includes profit booked on redemption.",
    tooltipId: "annualisedReturns",
  });

  // portfolio['investmentGraph'] = getPlotChart(portfolioGraph);

  return portfolio;
}

function getInvestmentDetails(portfolio, portfolioGraph) {
  var investmentDetails =
    process.env.REACT_APP_AMAZON_DASHBOARD === "false"
      ? {
          funds: [],
          sips: [],
          timeline:
            (store.getState().portfolio.portfolio &&
              store.getState().portfolio.portfolio.investmentDetails &&
              store.getState().portfolio.portfolio.investmentDetails
                .timeline) ||
            {},
        }
      : {
          funds: [],
          timeline:
            (store.getState().portfolio.portfolio &&
              store.getState().portfolio.portfolio.investmentDetails &&
              store.getState().portfolio.portfolio.investmentDetails
                .timeline) ||
            {},
        };

  //Format funds data:
  investmentDetails.funds = getFormattedFunds(
    portfolio.portfolioDetails.funds,
    portfolio
  );

  //Format SIP data:
  // investmentDetails.sips = getFormattedSips(portfolio.activeSips);

  //Format Timeline data:
  // investmentDetails.timeline = getFormattedTransactions(portfolio.transactionHistory);

  return investmentDetails;
}

function getFormattedFunds(funds, portfolioGraph) {
  var formattedFunds = [];
  funds.map((fund) => {
    if (fund.investmentAmt > 0) {
      var fundInfo = {};
      fundInfo["graphDetails"] =
        find((portfolioGraph && portfolioGraph.funds) || [], function(
          graphFund
        ) {
          return graphFund.codeAMFI === fund.codeAMFI;
        }) || {};

      // if(fundInfo.graphDetails) {
      let fName = fund.schemeName || "";
      fundInfo["name"] = fName ? fName.toLowerCase() : fName;
      fundInfo["id"] = fund.codeAMFI;
      fundInfo["type"] = fund.type;
      fundInfo["cutOffTime"] = utils.getCutoffTime(fund.type);
      fundInfo["transactionHistory"] = fund.txs;
      fundInfo["units"] = fund.units ? fund.units.toFixed(2) : 0;
      fundInfo["mtm"] = fund.mtm ? fund.mtm : 0;
      fundInfo["isDirect"] = fund.isDirect;

      fundInfo["capitalGains"] = utils.formatCurrency(
        fundInfo.graphDetails.capitalGains || 0
      );
      fundInfo["pnlValue"] = fund.absolutePnlPerc || 0; //(fundInfo.graphDetails.capitalGains * 100 / fundInfo.graphDetails.currInvestAmt).toFixed(2);
      fundInfo["nav"] = fund.nav || 0;

      fundInfo["ownedFundStatus"] = fund.status || fund.originalStatus;
      // var savingsValue = fundInfo.graphDetails.cmsnSaved ? utils.formatCurrency(fundInfo.graphDetails.cmsnSaved) : '-'; //utils.formatCurrency(0)
      var savingsValue = fund.cmsnSaved
        ? fund.cmsnSaved.oroNumber(0, true)
        : fund.cmsnPaid.oroNumber(0, true);

      fundInfo["savings"] = savingsValue;
      fundInfo["cmsnSaved"] = fund.cmsnSaved;
      fundInfo["cmnsType"] = fund.cmsnSaved ? "saved" : "paid";

      fundInfo["xirr"] = fund.xirr;
      fundInfo["investmentAmt"] = fund.investmentAmt;
      fundInfo["type"] = fund.type;

      fundInfo["ownedFundDetails"] = [];
      fundInfo.ownedFundDetails.push({
        title: "Invested",
        value: utils.formatCurrency(fund.investmentAmt || 0),
      });
      fundInfo.ownedFundDetails.push({
        title: "NAV",
        value: utils.formatCurrency(fund.nav || 0),
      });
      fundInfo.ownedFundDetails.push({
        title: "Units",
        value: fund.units ? fund.units.toFixed(2) : "-",
      });

      fundInfo["totalInvestment"] = fund.mtm && fund.mtm.oroNumber(0, true);
      fundInfo["yesterdaysPnlPerc"] = fund.yesterdaysPnlPerc;
      fundInfo["yesterdaysPnl"] = fund.yesterdaysPnl;

      fundInfo["info"] = [];
      fundInfo.info.push({
        title: "Current Value",
        value: fund.mtm && fund.mtm.oroNumber(0, true),
      });
      fundInfo.info.push({
        title: "Invested Amount",
        value: fund.investmentAmt && fund.investmentAmt.oroNumber(0, true),
      });
      fundInfo.info.push({
        title: "Absolute P/L",
        value: "₹" + (fund.absolutePL || "-"),
        color: fund.absolutePL >= 0 ? "primary" : "danger",
      });
      // if(fund.isDirect) {
      //   fundInfo.info.push({title: 'Savings', value: savingsValue, color: 'primary'});
      // } else {
      //   fundInfo.info.push({title: 'Commission', value: fund.cmsnPaid != '-' ? utils.formatCurrency(fund.cmsnPaid) : fund.cmsnPaid, color: 'danger'});
      // }

      // fundInfo.info.push({title: 'Type', value: fund.type});

      formattedFunds.push(fundInfo);
      // }
    }
  });
  return formattedFunds;
}

function getFundsSortingOptions() {
  return [
    {
      value: "name",
      label: "Fund Name",
    },
    {
      value: "xirr",
      label: "Annualised Returns",
    },
    {
      value: "investmentAmt",
      label: "Investment Amount",
    },
  ];
}

function getSipsFilterOptions() {
  return [
    {
      value: "all",
      label: "All SIPs",
    },
    {
      value: "Active",
      label: "Active SIPs",
    },
    {
      value: "Inactive",
      label: "Inactive SIPs",
    },
    // {
    //   value: "Ended",
    //   label: "Ended SIPs",
    // },
    // {
    //   value: "Cancelled",
    //   label: "Cancelled SIPs",
    // },
  ];
}

function formatSellPf(funds) {
  if (funds && funds.length > 0) {
    funds.map((fund) => {
      if (fund) {
        fund["pnlValue"] =
          ((fund.currMtm - fund.currInvestAmt) * 100) / fund.currInvestAmt;
      }
    });
  }

  return funds;
}

function getCommissionAnalysis(cmsnAnalysis) {
  if (cmsnAnalysis && cmsnAnalysis.length > 0) {
    var regularFunds = cmsnAnalysis.filter((fund) => {
      return fund["DirectOrRegular"] === "Regular";
    });

    if (regularFunds && regularFunds.length > 0) {
      var cmsnAmount = 0;
      regularFunds.map((fund) => {
        if (fund.cmsnPaid) {
          cmsnAmount += fund.cmsnPaid;
        }
      });
      return cmsnAmount;
    }
  }

  return 0;
}

function getFormattedSipsOvd(activeSips) {
  var sips = [];

  activeSips.map((sip) => {
    var sipInfo = {};
    sipInfo["pan"] = sip["pan"];
    sipInfo["can"] = sip["can"];
    sipInfo["type"] = sip["type"];
    sipInfo["sid"] = sip["sid"];
    sipInfo["status"] = sip["status"];
    sipInfo["statusDesc"] = sip["statusDesc"];
    sipInfo["fn"] = sip["fn"];
    sipInfo["fundCode"] = sip["fundCode"];
    sipInfo["schemeCode"] = sip["schemeCode"];
    sipInfo["schemeCodeTo"] = sip["schemeCodeTo"];
    sipInfo["schemeName"] = sip["schemeName"];
    sipInfo["schemeNameTo"] = sip["schemeNameTo"];
    sipInfo["amt"] = utils.formatCurrency(sip["amt"]);
    sipInfo["period"] = sip["period"];
    sipInfo["day"] = sip.ni ? sip.ni : sip.day;
    sipInfo["sd"] = sip["sd"];
    sipInfo["ed"] = sip["ed"];
    sipInfo["td"] = sip["td"];
    sipInfo["src"] = sip["src"];
    sipInfo["arn"] = sip["arn"];
    sips.push(sipInfo);
  });

  return sips;
}

function getFormattedSips(activeSips) {
  var sips = [];

  activeSips.map((sip) => {
    var sipInfo = {};
    // sipInfo["pan"] = sip["pan"]
    // sipInfo['can'] = sip['can']
    // sipInfo["type"] = sip["type"]
    // sipInfo["sid"] = sip["sid"]
    // sipInfo["status"] = sip["status"]
    // sipInfo["statusDesc"] = sip["statusDesc"]
    // sipInfo["fn"] =sip["fn"]
    // sipInfo["fundCode"] = sip["fundCode"]
    // sipInfo["schemeCode"] = sip["schemeCode"]
    // sipInfo["schemeCodeTo"] = sip["schemeCodeTo"]
    // sipInfo["schemeName"] = sip["schemeName"]
    // sipInfo["amt"] = utils.formatCurrency(sip["amt"])
    // sipInfo["period"] = sip["period"]
    // sipInfo["day"] =sip.day
    // sipInfo["sd"] = sip["sd"]
    // sipInfo["ed"] = sip["ed"]
    // sipInfo["td"] = sip["td"]
    // sipInfo["src"] = sip["src"]
    // sipInfo["arn"] = sip["arn"]
    sipInfo["can"] = sip["CAN Number"];
    sipInfo["id"] = sip.codeAMFI;
    sipInfo["frequencyName"] = sip.frequencyDisplayName;
    sipInfo["name"] = sip["Fund Scheme Name"]
      ? sip["Fund Scheme Name"].toLowerCase()
      : sip["Fund Scheme Name"];
    sipInfo["transactionHistory"] = sip["cmpltData"]; //sip.txs;
    sipInfo["installment"] = utils.formatCurrency(sip["Investment Amount"]);
    sipInfo["installmentDay"] = utils.addSuffixToNumber(sip["Installment Day"]);
    sipInfo["refNumber"] = sip["Entity Order Ref No"];
    sipInfo["schemeName"] = sip["Fund Scheme Name"];
    sipInfo["schemeNameTo"] = sip["schemeNameTo"];
    sipInfo["type"] = sip.typeDisplayName;
    sipInfo["frequency"] = sip.frequencyDisplayName;
    sipInfo["investmentAmount"] = sip["Investment Amount"];
    sipInfo["investmentAmountTillDate"] = new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(sip["amtInvstdTillDate"]);
    sipInfo["sipStatus"] = sip["sipStatus"];
    sipInfo["numInstallments"] = sip["Number of Installments"];
    sipInfo["todaysVal"] = new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(sip["todaysVal"]);
    sipInfo["percentPnl"] =
      sip["percentPnl"] && sip["percentPnl"] !== "-"
        ? sip["percentPnl"].toFixed(2)
        : "-";
    sipInfo["unitsHeld"] =
      sip["final_units"] && sip["final_units"] !== "-"
        ? sip["final_units"].toFixed(2)
        : "-";
    sipInfo["nextInstallment"] = sip["Next Installment Day"];

    sipInfo["endDate"] = sip["End Date"]
      ? utils.convertDateFormatDesc(sip["End Date"])
      : utils.convertDateFormatDesc(
          utils.getDateFromStartDate(
            sip["Start Date"],
            sip["Number of Installments"]
          )
        );
    sipInfo["startDate"] = utils.convertDateFormatDesc(sip["Start Date"]);
    sipInfo["sipRegistrationId"] = sip["sipRegistrationId"];
    sips.push(sipInfo);
  });

  return sips;
}

function getFormattedTransactions(txnHistory) {
  var timeline = {};
  var transactionHistory = {};
  var timelineDurations = getTimelineDurations();

  var transactionTypes = [{ label: "All Transactions", value: "all" }];

  if (txnHistory) {
    Object.keys(txnHistory).map((key) => {
      let results =
        txnHistory[key] &&
        txnHistory[key].map((txn) => {
          // if (txn.transactionInfo.length > 0) {
          //   let txnObject = txn.transactionInfo.map(info => {
          //     var o = Object.assign({}, info);
          //     o.type = key;
          //     return o;
          //   });

          //   txn.transactionInfo = txnObject;

          //   var t = txn.transactionInfo[txn.transactionInfo.length - 1];
          //   var transactionDetails = {};
          //   transactionDetails['transactionStatusCode'] = t.TransactionStatus;
          //   transactionDetails['transactionStatus'] = utils.getTransactionStatusLabel(t.TransactionStatus);
          //   transactionDetails['transactionEntries'] = getTransactionEntries(t);

          //   var date = new Date(t['Order Timestamp']);
          //   transactionDetails['date'] = date.getDate() + ' ' + utils.getMonthName(date.getMonth()) + ', ' + date.getFullYear();
          //   transactionDetails['time'] = date.toLocaleTimeString('en-IN', {hour: '2-digit', minute: '2-digit'});

          //   txn['transactionDetails'] = transactionDetails;

          //   return txn;
          // } //endif;

          var transactionDetails = {};
          transactionDetails["transactionStatusCode"] = txn.status;
          transactionDetails[
            "transactionStatus"
          ] = utils.getTransactionStatusLabel(txn.status, txn.cartType);
          transactionDetails[
            "transactionStatusColor"
          ] = utils.getTransactionStatusColor(
            transactionDetails["transactionStatus"]
          );

          transactionDetails["transactionEntries"] = getTransactionEntries(txn);
          // transactionDetails['transactionEntries'] = getTransactionEntries(t);

          var date = new Date(txn.date);
          transactionDetails["date"] =
            date.getDate() +
            " " +
            utils.getMonthName(date.getMonth()) +
            ", " +
            date.getFullYear();
          transactionDetails["time"] = date.toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
          });

          txn["transactionDetails"] = transactionDetails;

          return txn;
        });

      //results = results && results.filter(result => result);
      if (results.length > 0) {
        transactionHistory[key] = results;
      }

      transactionTypes.push({
        label: utils.getTransactionTypeLabel(key),
        value: key,
      });
    });
  }

  timeline["transactionHistory"] = transactionHistory;
  timeline["transactionTypes"] = transactionTypes;
  timeline["timelineDurations"] = timelineDurations;

  return timeline;
}

function getTransactionEntries(txn) {
  var transactionEntries = [];
  var transaction = {};
  switch (txn.cartType) {
    case "cart":
    case "Purchase":
      transaction["title"] = "Purchased " + txn["dname"]; //RTA Scheme Name
      break;
    case "rcart":
    case "redeemCart":
    case "Redemption":
      transaction["title"] =
        "Redeemed " + (txn["dname"] ? txn["dname"] : txn["nameRTA"]);
      break;
    case "scart":
    case "switchCart":
      transaction["title"] = "Switched " + txn["nameToRTA"];
      break;
    case "sipcart":
    case "sipCart":
      transaction["title"] = "Set up SIP for " + txn["dname"];
      break;
    case "stpcart":
    case "stpCart":
      transaction["title"] =
        "Set up STP to switch " + txn["fromFund"] + " to " + txn["toFund"];
      break;
    case "swpcart":
    case "swpCart":
      transaction["title"] = "Set up SWP to redeem " + txn["dname"];
      break;
    default:
      transaction["title"] = txn["dname"];
      break;
  }

  transaction["title"] = transaction["title"]
    ? transaction["title"].toLowerCase()
    : transaction["title"];

  transaction["amount"] = txn["amount"]
    ? utils.formatCurrency(txn["amount"])
    : "-"; //Response Amount
  switch (txn.cartType) {
    case "cart":
    case "Purchase":
    case "rcart":
    case "redeemCart":
    case "Redemption":
      transaction["description"] = txn["units"]
        ? txn["units"] === "ALL"
          ? txn["units"]
          : txn["units"].oroNumber(2)
        : "-";
      transaction["description"] =
        transaction["description"] +
        " units at NAV " +
        (txn["nav"] ? utils.formatCurrency(txn["nav"]) : "-");
      break;
    case "stpcart":
    case "stpCart":
    case "sipcart":
    case "sipCart":
    case "swpcart":
    case "swpCart":
      transaction["description"] =
        (txn.frequency ? txn.frequency + " | " : "") +
        utils.getMonthName(txn.startDate.substring(0, 2) - 1) +
        " " +
        txn.startDate.substring(2) +
        " - " +
        utils.getMonthName(txn.endDate.substring(0, 2) - 1) +
        " " +
        txn.endDate.substring(2);
      break;
    default:
      transaction["description"] = "";
      break;
  }

  transactionEntries.push(transaction);

  return transactionEntries;
}

function getPlotChart(portfolioGraph) {
  var data = portfolioGraph.dvpArr || [];
  var averagedData = [
    {
      id: "investments",
      data: [],
    },
  ];

  chunk(data, 30).map((item, i) => {
    averagedData[0].data.push({
      x: averagedData[0].data.length,
      y: item[item.length - 1],
    });
  });

  return averagedData;
}

function getGraphDetails(portfolioGraph) {
  var graph = {
    investmentGraph: {
      details: {},
    },
    returnsGraph: {
      details: {
        data: [],
        keys: ["y"],
        indexBy: "name",
      },
    },
    benchmarkGraph: {
      details: [
        {
          data: [],
          id: "Benchmark returns",
        },
        {
          data: [],
          id: "Portfolio returns",
        },
      ],
    },
    currentAssetAllocation: [],
    sectorAllocation: [],
    companyAllocation: [],
  };

  if (portfolioGraph) {
    const investmentChart = zipWith(
      portfolioGraph.dvpDatesArr || [],
      portfolioGraph.dvpArr,
      (x, y) => ({ y, x })
    );

    var tabs = [
      { key: "month", label: "Month" },
      { key: "quarter", label: "Quarter" },
      { key: "year", label: "Year" },
      { key: "all", label: "All" },
    ];

    var graphs = {};

    for (var i = 0; i < tabs.length; i++) {
      var temp = getInvestmentGraphDetails(investmentChart, tabs[i].key);
      graphs[tabs[i].key] = [
        {
          id: tabs[i].key,
          data: [],
        },
      ];

      graphs[tabs[i].key][0].data = temp;
    }

    graph.investmentGraph["tabs"] = tabs;
    graph.investmentGraph.details = graphs;

    graph.returnsGraph.details.data = portfolioGraph.xirrFYArr;

    //Benchmark graph:
    var dates = portfolioGraph.dvpDatesArr;
    if (portfolioGraph.bmNormArr.length < portfolioGraph.dvpDatesArr.length) {
      dates = portfolioGraph.dvpDatesArr.slice(
        0,
        portfolioGraph.bmNormArr.length
      );
    }

    var benchmarks = zipWith(dates, portfolioGraph.bmNormArr, (x, y) => ({
      y,
      x,
    }));
    graph.benchmarkGraph.details[0].data.push(formatForMonth(benchmarks[0]));
    chunk(benchmarks, 30).map((item, i) => {
      graph.benchmarkGraph.details[0].data.push(
        formatForMonth(item[item.length - 1])
      );
    });
    graph.benchmarkGraph["tabs"] = tabs;
    //Portfolio graph
    if (portfolioGraph.dvpNormArr.length < portfolioGraph.dvpDatesArr.length) {
      dates = portfolioGraph.dvpDatesArr.slice(
        0,
        portfolioGraph.dvpNormArr.length
      );
    }

    var portfolio = zipWith(dates, portfolioGraph.dvpNormArr, (x, y) => ({
      y,
      x,
    }));
    graph.benchmarkGraph.details[1].data.push(formatForMonth(portfolio[0]));
    chunk(portfolio, 30).map((item, i) => {
      graph.benchmarkGraph.details[1].data.push(
        formatForMonth(item[item.length - 1])
      );
    });

    //Make sure both arrays have same length.
    if (
      graph.benchmarkGraph.details[0].data.length !==
      graph.benchmarkGraph.details[1].data.length
    ) {
      var croppedArray = [];
      if (
        graph.benchmarkGraph.details[0].data.length >
        graph.benchmarkGraph.details[1].data.length
      ) {
        croppedArray = graph.benchmarkGraph.details[0].data.slice(
          0,
          graph.benchmarkGraph.details[1].data.length
        );
        graph.benchmarkGraph.details[0].data = croppedArray;
      } else {
        croppedArray = graph.benchmarkGraph.details[1].data.slice(
          0,
          graph.benchmarkGraph.details[0].data.length
        );
        graph.benchmarkGraph.details[1].data = croppedArray;
      }
    }

    graph["annualisedReturns"] = portfolioGraph.xirr;
    graph["benchmarkReturns"] = portfolioGraph.bmRets
      ? portfolioGraph.bmRets.toFixed(2)
      : 0;
    graph["portfolioReturns"] = portfolioGraph.dvpRets
      ? portfolioGraph.dvpRets.toFixed(2)
      : 0;

    //Asset Allocation graph
    if (portfolioGraph.astClsArr && portfolioGraph.astClsArr.length > 0) {
      portfolioGraph.astClsArr.map((assetData) => {
        assetData["id"] = assetData.name;
        assetData["label"] = assetData.name + " - " + assetData.value + "%";
        assetData["value"] = parseFloat(assetData.value);
        return assetData;
      });
    }

    graph["currentAssetAllocation"] = portfolioGraph.astClsArr;

    //Sector Allocation graph
    if (portfolioGraph.sectorArr && portfolioGraph.sectorArr.length > 0) {
      portfolioGraph.sectorArr.map((assetData) => {
        assetData["id"] = assetData.name;
        assetData["value"] = parseFloat(assetData.perc).toFixed(2);
        assetData["label"] = assetData.name + " - " + assetData.value + "%";
        return assetData;
      });
    }

    graph["sectorAllocation"] = portfolioGraph.sectorArr;

    //Company Allocation graph
    if (portfolioGraph.companyArr && portfolioGraph.companyArr.length > 0) {
      portfolioGraph.companyArr.map((assetData) => {
        assetData["id"] = assetData.name;
        assetData["value"] = parseFloat(assetData.perc).toFixed(2);
        assetData["label"] = assetData.name + " - " + assetData.value + "%";
        return assetData;
      });
    }

    graph["companyAllocation"] = portfolioGraph.companyArr;
  }

  return graph;
}

function getInvestmentGraphDetails(chartData, key) {
  var details = [];
  var date;
  var temp;
  var arr;

  switch (key) {
    case "month":
      arr = chartData.slice(chartData.length - 30, chartData.length);
      // details.push({x:arr[0].x,y:0})
      details = arr;
      // arr.map((item,i) => {
      //   details.push(formatForMonth(item[item.length-1]));
      //   console.log('Array of month:'+JSON.stringify(formatForMonth(item[item.length-1])))
      // })
      break;
    case "quarter":
      arr = chartData.slice(chartData.length - 30 * 3, chartData.length);
      // details.push({x:arr[0].x,y:0})
      details = arr;
      // arr.map((item,i) => {
      //   details.push(formatForMonth(item[item.length-1]));
      //   console.log('Array of month:'+JSON.stringify(formatForMonth(item[item.length-1])))
      // })
      break;
    case "year":
      arr = chartData.slice(chartData.length - 30 * 12, chartData.length);
      // details.push({x:arr[0].x,y:0})
      details = arr;
      // arr.map((item,i) => {
      //   details.push(formatForMonth(item[item.length-1]));
      //   console.log('Array of month:'+JSON.stringify(formatForMonth(item[item.length-1])))
      // })
      break;
    case "all":
      // details.push(formatForDay(chartData[0]));

      // //Sometimes the array of all data is too long - ~1000 entries
      // //This makes the graph look unreadabla. So we'll chunk it to have approx 40 values on the x axis.
      // var divisor = Math.ceil(chartData.length / 40);
      // chunk(chartData, divisor).map((item,i) => {
      //   details.push(formatForDay(item[item.length-1]));
      // });
      arr = chartData.slice(0, chartData.length);
      // details.push({x:arr[0].x,y:0})
      details = arr;
      break;
  }

  return details;
}

function formatForYear(item) {
  try {
    var date = new Date(item.x);
    date = date.getFullYear();
    return {
      x: date,
      y: item.y,
    };
  } catch (error) {
    return {};
  }
  // let dateArr = item.x.split('-');
  // let mm = utils.getMonthNumber(dateArr[1]);
  // let str = dateArr[2]+'-'+mm+'-'+dateArr[0];
  // let formatDate = new Date(str);
  // return {
  //   x: formatDate,
  //   y: item.y
  // };
}

function formatForMonth(item) {
  try {
    var date = new Date(item.x);
    date = utils.getMonthName(date.getMonth()) + " " + date.getFullYear();
    return {
      x: date,
      y: item.y,
    };
  } catch (err) {
    return {};
  }
  // try {
  //   var date = new Date(item.x);
  //   let dateArr = item.x.split('-');
  //   let mm = utils.getMonthNumber(dateArr[1]);
  //   let str = dateArr[2]+'-'+mm+'-'+dateArr[0];
  //   let formatDate = new Date(str);
  //   return {
  //     x: formatDate,
  //     y: item.y
  //   };
  // } catch(err) {
  //   console.log('Error ',err,'err Item',item);
  //   return {};
  // }
}

function formatForDay(item) {
  try {
    var date = new Date(item.x);
    date =
      date.getDate() +
      " " +
      utils.getMonthName(date.getMonth()) +
      " " +
      date.getFullYear();
    return {
      x: date,
      y: item.y,
    };
  } catch (error) {
    return {};
  }
  // let dateArr = item.x.split('-');
  // let mm = utils.getMonthNumber(dateArr[1]);
  // let str = dateArr[2]+'-'+mm+'-'+dateArr[0];
  // let formatDate = new Date(str);
  // return {
  //   x: formatDate,
  //   y: item.y
  // };
}

function getTransactionHistory(txnHistory) {
  var transactionHistory = {};

  Object.keys(txnHistory).map((key) => {
    let results = txnHistory[key].map((txn) => {
      if (txn.transactionInfo.length > 0) {
        let txnObject = txn.transactionInfo.map((info) => {
          var o = Object.assign({}, info);
          o.type = key;
          return o;
        });

        txn.transactionInfo = txnObject;

        return txn;
      } //endif;
    });

    if (results.filter((item) => item).length > 0) {
      transactionHistory[key] = results;
    }

    return transactionHistory;
  });
}

function getTimelineDurations() {
  return [
    { label: "Last 1 month", value: 0 },
    { label: "Last 6 month", value: 1 },
    { label: "Last 1 year", value: 2 },
    { label: "Last 2 year", value: 3 },
    { label: "Last 3 year", value: 4 },
    { label: "All time", value: 5 },
  ];
}

function getFormattedFundTransactions(txnHistory) {
  txnHistory.map((txn) => {
    var transactionDetails = {};
    transactionDetails["transactionStatus"] = utils.getTransactionStatusLabel(
      txn["Transaction Status"]
    );
    transactionDetails["transactionEntries"] = getTransactionEntries(txn);
    var date = new Date(txn["Order Timestamp"]);
    transactionDetails["date"] =
      date.getDate() +
      " " +
      utils.getMonthName(date.getMonth()) +
      ", " +
      date.getFullYear();
    transactionDetails["time"] = date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
    });

    txn["transactionDetails"] = transactionDetails;

    return txn;
  });

  return txnHistory;
}

function getNavGraphData(graphData) {
  var tabs = [
    {
      label: "1 Month",
      value: "1m",
      chunkSize: 30,
    },
    {
      label: "3 Months",
      value: "3m",
      chunkSize: 30 * 3,
    },
    {
      label: "6 Months",
      value: "6m",
      chunkSize: 30 * 6,
    },
    {
      label: "1 Year",
      value: "1y",
      chunkSize: 30 * 12,
    },
    {
      label: "3 Years",
      value: "3y",
      chunkSize: 30 * 12 * 3,
    },
    {
      label: "5 Years",
      value: "5y",
      chunkSize: 30 * 12 * 5,
    },
  ];

  var graphs = {};

  tabs.map((tab) => {
    graphs[tab.value] = getGraphTabs(graphData, tab);
  });

  return {
    tabs: tabs,
    graphs: graphs,
  };
}

function getGraphTabs(graphData, tab) {
  var details = [];
  var temp = [];
  var i;

  switch (tab.value) {
    case "1m":
      // temp = graphData.slice(graphData.length-tab.chunkSize);
      // for(i=0; i < temp.length; i++) {
      //   details.push({
      //       x: formatDate(temp[i][0], true),
      //       y: temp[i][1]
      //     });
      // }
      details = null;
      break;
    case "3m":
      temp = graphData.slice(graphData.length - tab.chunkSize);
      chunk(temp, 7).map((item, i) => {
        var lastValue = item[item.length - 1];

        details.push({
          x: formatDate(lastValue[0], true),
          y: lastValue[1],
        });
      });
      break;
    case "6m":
      temp = graphData.slice(graphData.length - tab.chunkSize);
      chunk(temp, 15).map((item, i) => {
        var lastValue = item[item.length - 1];

        details.push({
          x: formatDate(lastValue[0], true),
          y: lastValue[1],
        });
      });
      break;
    case "1y":
      temp = graphData.slice(graphData.length - tab.chunkSize);
      chunk(temp, 30).map((item, i) => {
        var lastValue = item[item.length - 1];

        details.push({
          x: formatDate(lastValue[0], false),
          y: lastValue[1],
        });
      });
      break;
    case "3y":
      temp = graphData.slice(graphData.length - tab.chunkSize);
      chunk(temp, 90).map((item, i) => {
        var lastValue = item[item.length - 1];

        details.push({
          x: formatDate(lastValue[0], false),
          y: lastValue[1],
        });
      });
      break;
    case "5y":
      temp = graphData;
      chunk(temp, 90).map((item, i) => {
        var lastValue = item[item.length - 1];

        details.push({
          x: formatDate(lastValue[0], false),
          y: lastValue[1],
        });
      });
      break;
  }
  return details;
}

function formatDate(timestamp, showFullDate) {
  var date = new Date(timestamp);
  if (showFullDate) {
    date =
      date.getDate() +
      " " +
      utils.getMonthName(date.getMonth()) +
      ", " +
      date.getFullYear();
  } else {
    date = utils.getMonthName(date.getMonth()) + " " + date.getFullYear();
  }

  return date;
}
